import { Utils } from 'ecrion-components';

function getFileFromPath(path, workspace, publicId = '') {
  return Utils.request({
    method: 'GET',
    url: `${
      process.env.REACT_APP_WEBSITE_URL
    }/backend/portalfiles?path=${encodeURIComponent(
      path
    )}&workspace=${encodeURIComponent(workspace)}&publicId=${encodeURIComponent(
      publicId
    )}`,
  }).then((file) => {
    return file;
  });
}

function getFileFromJobId(jobId, communicationId, publicId = '') {
  return Utils.request({
    method: 'GET',
    url: `${
      process.env.REACT_APP_WEBSITE_URL
    }/backend/portalfiles?jobId=${encodeURIComponent(
      jobId
    )}&communicationId=${encodeURIComponent(
      communicationId
    )}&publicId=${encodeURIComponent(publicId)}`,
  }).then((file) => {
    return file;
  });
}

function getFileFromCommunicationId(communicationId, publicId = '') {
  return Utils.request({
    method: 'GET',
    url: `${
      process.env.REACT_APP_WEBSITE_URL
    }/backend/portalfiles?communicationId=${encodeURIComponent(
      communicationId
    )}&publicId=${encodeURIComponent(publicId)}`,
  }).then((file) => {
    return file;
  });
}

function getFileFromCommunicationName(communicationName, publicId = '') {
  return Utils.request({
    method: 'GET',
    url: `${
      process.env.REACT_APP_WEBSITE_URL
    }/backend/portalfiles?communicationName=${encodeURIComponent(
      communicationName
    )}&publicId=${encodeURIComponent(publicId)}`,
  }).then((file) => {
    return file;
  });
}

export {
  getFileFromPath,
  getFileFromJobId,
  getFileFromCommunicationId,
  getFileFromCommunicationName,
};
